import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";
import { FiCalendar } from "react-icons/fi";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function TopDealsChart() {
  const [filter, setFilter] = useState("This Week");

  const dataMap = {
    "This Week": [569877, 484575, 184575],
    "Last Week": [400000, 350000, 150000],
    "This Month": [700000, 620000, 250000],
  };

  const data = {
    labels: ["Marketing", "Chat", "Email"],
    datasets: [
      {
        data: dataMap[filter],
        backgroundColor: ["#ff6a2c", "#3e6f7e", "#ffc107"],
        borderWidth: 0,
        spacing: 8, // 🔥 gap between arcs
        borderRadius: 20, // 🔥 rounded edges like image
        cutout: "70%", // 🔥 donut thickness
      },
    ],
  };

  const options = {
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#fff",
        titleColor: "#333",
        bodyColor: "#333",
        borderColor: "#ddd",
        borderWidth: 1,
      },
    },
  };

  const labels = ["Marketing", "Chat", "Email"];
  const colors = ["#ff6a2c", "#3e6f7e", "#ffc107"];

  return (
    <Card className="flex-fill top-deals-card h-100">
      <Card.Header className="d-flex justify-content-between card-header-custom align-items-center">
        <h5 className="mb-0 fw-semibold">Top Deals</h5>

        <Dropdown>
          <Dropdown.Toggle className="btn-white  custom-toggle d-flex text-dark align-items-center">
            <FiCalendar className="me-1" />
            {filter}
          </Dropdown.Toggle>

          <Dropdown.Menu align="end">
            {["This Month", "This Week", "Last Week"].map((item) => (
              <Dropdown.Item key={item} onClick={() => setFilter(item)}>
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      <Card.Body className="text-center">
        {/* CHART */}
        <div className="chart-wrapper">
          <Doughnut data={data} options={options} />
        </div>

        {/* STATUS */}
        <div className="mt-4 text-start">
          <h6 className="fw-semibold mb-3">Status</h6>

          {labels.map((label, i) => (
            <div
              key={label}
              className="d-flex justify-content-between align-items-center mb-2"
            >
              <div className="d-flex align-items-center">
                <span
                  className="dot me-2"
                  style={{ background: colors[i] }}
                ></span>
                <span className="text-muted">{label}</span>
              </div>

              <span className="fw-medium">
                ₹{dataMap[filter][i].toLocaleString("en-IN")}
              </span>
            </div>
          ))}
        </div>
      </Card.Body>

      <style>{`
        .top-deals-card {
         border-radius:5px;
border:2px solid #e5e7eb;
        }

              .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
        .chart-wrapper {
          width: 220px;
          margin: 0 auto;
        }

        /* DOT */
        .dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          display: inline-block;
        }

        /* BUTTON */
        .btn-white {
          background: #fff;
          border: 1px solid #e5e7eb;
          padding: 6px 12px;
          font-size: 14px;
          border-radius: 8px;
        }

        /* ❌ remove blue */
        .custom-toggle::after {
          display: none !important;
        }

        .custom-toggle:focus,
        .custom-toggle:active,
        .custom-toggle.show {
          box-shadow: none !important;
          border-color: #ff6a2c !important;
          color: #ff6a2c !important;
        }

        .custom-toggle:hover {
          border-color: #ff6a2c !important;
          color: #ff6a2c !important;
        }

        /* DROPDOWN */
        .dropdown-menu {
          border-radius: 8px;
          padding: 6px;
        }

        .dropdown-item {
          border-radius: 6px;
          font-size: 14px;
        }

        .dropdown-item.active,
        .dropdown-item:active {
          background: #ff6a2c !important;
          color: #fff !important;
        }

        .dropdown-item:hover {
          background: #fff4ed;
          color: #ff6a2c;
        }
      `}</style>
    </Card>
  );
}